import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { progressFlgState } from '../../GlobalState';
import {
  Checkbox,
  Modal,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import { formatDatetime, formatDataSize } from '../../utils/common';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import { getFileDownload } from '../../apicalls/cloud/shareFile';
import { FileDetailField } from './FileDetailField';
import { PreviewField } from '../fileListPage/Preview';
import { PdfIcon } from '../parts/svgIcon/FileIcon';
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';
import type { TSharedFile } from '../../types/cloudStorage/CloudFileList';
import { CustomTooltip } from '../tooltip/CustomTooltip';

type Tprops = {
  file: TSharedFile;
  addSelectedFiles: () => void;
  removeSelectedFiles: () => void;
  selectedFiles: TSharedFile[];
  getSharedFileList: () => void;
  isGuestFile: boolean;
};

export const FileList: React.FC<Tprops> = (props: Tprops) => {
  const {
    file,
    addSelectedFiles,
    removeSelectedFiles,
    selectedFiles,
    getSharedFileList,
    isGuestFile
  } = props;

  const classes = useStyles();
  // プレビュー
  const [src, setSrc] = useState<string>('');
  const [openPreview, setOpenPreview] = useState<boolean>(false);
  // ローディング
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  // 編集モーダル表示
  const [openDetailModal, setOpenDetailModal] = useState<boolean>(false);

  const onDownload = async () => {
    if (!file) return;
    setProgressFlg(true);

    await getFileDownload(String(file.id), true).then((data: any) => {
      // 書類ダウンロード
      let bin = atob(data.data.replace(/^.*,/, ''));

      let buffer = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }

      let fileData = new File([buffer.buffer], data.data, {
        type: data.file_format
      });

      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(fileData);
      const fileName = file.name;
      downloadLink.download = fileName;
      downloadLink.click();
    });

    setProgressFlg(false);
  };

  const PdfPreview = async () => {
    if (!file) return;
    setProgressFlg(true);

    await getFileDownload(String(file.id), false).then((data: any) => {
      let bin = atob(data.data.replace(/^.*,/, ''));

      let buffer = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }

      let image_file = new File([buffer.buffer], data.data, {
        type: data.file_format
      });
      setSrc(URL.createObjectURL(image_file));
      setOpenPreview(true);
    });

    setProgressFlg(false);
  };

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = event.target.checked;
    if (checked) {
      addSelectedFiles();
    } else {
      removeSelectedFiles();
    }
  };

  useEffect(() => {}, [selectedFiles]);

  return (
    <>
      <TableBody>
        <StyledTableRow className='click_table_row' title=''>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 10 }}
            align='center'
          >
            <Checkbox
              checked={
                selectedFiles.find(selectedFile => selectedFile.id === file.id)
                  ? true
                  : false
              }
              onChange={handleCheck}
              color='default'
            />
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 300 }}
            align='center'
            onClick={() => {
              setOpenDetailModal(true);
            }}
          >
            {file.name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 120 }}
            align='center'
            onClick={() => {
              setOpenDetailModal(true);
            }}
          >
            {file.file_type_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 120 }}
            align='right'
            onClick={() => {
              setOpenDetailModal(true);
            }}
          >
            {formatDataSize(file.size)}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 120 }}
            align='right'
            onClick={() => {
              setOpenDetailModal(true);
            }}
          >
            {formatDatetime(new Date(file.exchange_date), 'YYYY年MM月DD日')}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 40 }}
            align='center'
          >
            {isGuestFile && (
              <CustomTooltip title={'編集'} placement='top'>
                <div
                  className={classes.icon}
                  onClick={() => {
                    setOpenDetailModal(true);
                  }}
                >
                  <EditIcon />
                </div>
              </CustomTooltip>
            )}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 40 }}
            align='center'
          >
            <CustomTooltip title={'ダウンロード'} placement='top'>
              <div className={classes.icon} onClick={onDownload}>
                <GetAppIcon />
              </div>
            </CustomTooltip>
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 40 }}
            align='center'
          >
            {file.format == 'application/pdf' && (
              <CustomTooltip title={'PDFプレビュー'} placement='top'>
                <div className={classes.icon} onClick={PdfPreview}>
                  <PdfIcon width={21} height={26} />
                </div>
              </CustomTooltip>
            )}
          </StyledTableCell>
        </StyledTableRow>
      </TableBody>

      {/* PDFプレビュー */}
      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}
        open={openPreview}
        onClose={() => setOpenPreview(false)}
      >
        <PreviewField
          src={src}
          openPreview={openPreview}
          setOpenPreview={setOpenPreview}
        />
      </Modal>

      {/* 書類詳細表示モーダル */}
      <Modal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <FileDetailField
          file={file}
          setOpenDetailModal={setOpenDetailModal}
          getSharedFileList={getSharedFileList}
          isGuestFile={isGuestFile}
        />
      </Modal>
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 120,
      backgroundColor: '#FFFFFF'
    },
    formControl1: {
      minWidth: 120,
      height: 30,
      borderRadius: 5,
      borderWidth: 1,
      paddingLeft: 5
    },
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#999999 !important`,
      color: '#FFFFFF',
      padding: 10,
      fontWeight: 'bold'
    },
    input: {
      borderColor: '#CCCCCC',
      padding: 5,
      margin: 10
    },
    table1: {
      padding: 8,
      wordBreak: 'break-all'
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 15
    },
    modal: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    searchBtn: {
      marginBottom: 10,
      marginRight: 20,
      marginLeft: 20,
      backgroundColor: '#52555F'
    },
    icon: {
      width: 40,
      height: 40,
      margin: 'auto',
      borderRadius: '50%',
      backgroundColor: '#E0E0E0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })
);

// スタイル関係
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);
